<ng-container *ngrxLet="kataloge$ as kataloge">
  <div class="header">
    @if (!expanded() && kataloge.length > 0) {
      <div class="header__spinner">
        <mat-spinner [diameter]="24" />
      </div>
    }

    <div class="header-title">
      <span class="header-title__count">{{ kataloge.length }}</span>
      <span class="header-title__label">Kataloge in Freigabe</span>
    </div>

    <div class="header-expander">
      <button class="header-expander__button" mat-button [disabled]="kataloge.length === 0" (click)="toggleExpand()">
        <div class="header-expander__button-label">
          @if (expanded()) {
            <span>Schließen</span>
            <mat-icon>arrow_drop_up</mat-icon>
          } @else {
            <span>Öffnen</span>
            <mat-icon>arrow_drop_down</mat-icon>
          }
        </div>
      </button>
    </div>
  </div>

  <div class="body" [class]="{ 'body--expanded': expanded() }">
    @for (katalog of kataloge; track katalog.catalogId) {
      <mat-card class="queued-catalog">
        <div class="queued-catalog__icon">
          @if (katalog.job.status === 'Awaiting') {
            <mat-icon>schedule</mat-icon>
          }
          @if (katalog.job.status === 'Processing') {
            <mat-spinner [diameter]="24" />
          }
        </div>
        <div class="queued-catalog__supplier truncate">{{ katalog.supplierReference.name }}</div>
        <div class="queued-catalog__name truncate">{{ katalog.name }}</div>
        <div class="queued-catalog__state truncate">
          @if (katalog.job.status === 'Awaiting') {
            <span class="queued-catalog__state-label"> Eingeplant </span>
          }
          @if (katalog.job.status === 'Processing') {
            <span>
              <span class="queued-catalog__state-label">Gestartet</span>
              <span class="queued-catalog__state-timing">{{ katalog.job.started | date }}</span>
            </span>
          }
        </div>
      </mat-card>
    }
  </div>
</ng-container>
